import { useMemo } from 'react';
import { IdName } from "../../../common/types/IdName";

const useTournamentsOptions = (allCompetitions: IdName[], allGroups: IdName[], allPhases: IdName<IdName>[]) => {

    const competitions = useMemo(() => {
        return allCompetitions?.map((comp: { id: any; name: any; }) => ({
            value: comp.id,
            text: comp.name,
        }))
    }, [allCompetitions])

    const series = useMemo(() => {
        return allPhases?.map((phase) => ({
            key: phase.id,
            value: phase.id,
            text: phase.name,
        }))
    }, [allPhases])

    const tourTypes = [
        { key: 0, value: 0, text: "League"},
        { key: 1, value: 1, text: "Knockout"},
        { key: 2, value: 2, text: "Shootout"},
        { key: 3, value: 3, text: "Standalone"},
    ]

    return (
        {competitions, series,tourTypes}
    );
};

export default useTournamentsOptions;
